import { render, staticRenderFns } from "./PromoPreview.vue?vue&type=template&id=7b636a42&scoped=true&"
import script from "./PromoPreview.vue?vue&type=script&lang=ts&"
export * from "./PromoPreview.vue?vue&type=script&lang=ts&"
import style0 from "./PromoPreview.vue?vue&type=style&index=0&id=7b636a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b636a42",
  null
  
)

export default component.exports